var exports = {
  "kL": "x805b157e--6fe012--container",
  "Qs": "x805b157e--6fe012--content",
  "iE": "x805b157e--6fe012--wrapper",
  "Sl": "x805b157e--6fe012--image",
  "Pf": "x805b157e--6fe012--label",
  "LP": "x805b157e--6fe012--accessory",
};

module.exports = exports;
